import React, { ReactElement, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useForm, Controller } from 'react-hook-form';
import Switch from 'react-switch';
import Radio from '../controls/Radio';
import Button from '../controls/Button';
import { createNotification, editNotification } from '../services/dashboard-service';
import CustomRadio from '../controls/CustomRadio';

type NotifyAlerts = 'All Alerts' | 'Only Alerts I am assigned' | 'Only Critical alerts' | 'None';
type NotifyEmailSms = 'sms' | 'email';

/**
 * FormData.
 */
interface FormData {
  notifyAllAlerts: NotifyAlerts;
  notifyEmailOrSms: NotifyEmailSms;
}

/**
 * NotificationSettings component for managing notification settings.
 * @returns React element representing the notification settings.
 */
function NotificationSettings(): ReactElement {
  const { state } = useLocation();
  const navigate = useNavigate();
  // const [notifyAllAlerts, setNotifyAllAlerts] = useState<NotifyAlerts | null>(
  //   state?.notifications?.events
  // );
  // const [notifyEmailOrSms, setNotifyEmailOrSms] = useState<NotifyEmailSms | null>(
  //   state?.notifications?.notificationDestination
  // );
  const [notifyIssue, setNotifyIssue] = useState<boolean>(true);
  const [notifyResolvedIssue, setNotifyResolvedIssue] = useState<boolean>(
    state?.notifications?.notifyResolvedIssue
  );
  const [faultDetection, setFaultDetection] = useState<boolean>(
    state?.notifications?.faultDetectionEnabled
  );
  const [loading, setLoading] = useState(false);
  const { handleSubmit, control, reset } = useForm<FormData>();

  /**
   * Handle create and Edit the Notification.
   * @param param - Required Parameters.
   */
  const onSubmit = async (param: FormData): Promise<void> => {
    const { notifyAllAlerts, notifyEmailOrSms } = param;
    if (state?.notifications?.id == null) {
      const data = {
        facilityId: 1,
        events: notifyAllAlerts,
        notificationDestination: notifyEmailOrSms,
        faultDetectionEnabled: faultDetection,
        notifyResolvedIssue
      };
      try {
        setLoading(true);
        await createNotification(data);
        toast.success('Notification Successfully Added');
        navigate('/settings');
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        toast.error('Something went wrong');
      }
    } else {
      const payload = {
        id: state?.notifications?.id,
        facilityId: 1,
        events: notifyAllAlerts,
        notificationDestination: notifyEmailOrSms,
        faultDetectionEnabled: faultDetection,
        notifyResolvedIssue
      };
      try {
        setLoading(true);
        await editNotification(state?.notifications?.id, payload);
        toast.success('Notificaion changes are Successful');
        navigate('/settings');
      } catch (e) {
        toast.error('Something went wrong');
      }
    }
  };
  /**
   * Function on click of Reset.
   */
  const handleOnReset = (): void => {
    setNotifyResolvedIssue(true);
    setFaultDetection(false);
    setNotifyIssue(true);
  };

  return (
    <div className="my-6 mx-2 p-6 flex flex-1 flex-col justify-between bg-container-500 rounded text-white">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <h1 className="text-lg font-semibold">Notification</h1>
          <div className="border-t mt-6 pt-8 border-t-gray-900 gap-14 flex flex-col">
            <div className="grid grid-cols-12">
              <div className="col-span-3">
                <div className="text-sm leading-5 font-light font-inter text-gray-300">
                  Notify me about
                </div>
                <div className="leading-5 font-light font-inter text-white text-sm mt-2">
                  Customise what you should be notified about
                </div>
              </div>
              <div className="flex flex-col gap-6 col-span-3 col-start-5">
                <Controller
                  name="notifyAllAlerts"
                  control={control}
                  defaultValue={state?.notifications?.events ?? 'All Alerts'}
                  render={({ field: { onChange, value } }) => (
                    <>
                      <div>
                        <Radio
                          label="All Alerts"
                          id="allAlerts"
                          value="All Alerts"
                          checked={value === 'All Alerts'}
                          onValueChange={(eventsvalue) => onChange(eventsvalue)}
                        />
                      </div>
                      <div>
                        <Radio
                          label="Only Alerts I am assigned"
                          id="assignedAlerts"
                          value="Only Alerts I am assigned"
                          checked={value === 'Only Alerts I am assigned'}
                          onValueChange={(eventsvalue) => onChange(eventsvalue)}
                        />
                      </div>
                      <div>
                        <Radio
                          label="Only Critical alerts"
                          id="criticalAlerts"
                          value="Only Critical alerts"
                          checked={value === 'Only Critical alerts'}
                          onValueChange={(eventsvalue) => onChange(eventsvalue)}
                        />
                      </div>
                      <div>
                        <Radio
                          label="None"
                          id="none"
                          value="None"
                          checked={value === 'None'}
                          onValueChange={(eventsvalue) => onChange(eventsvalue)}
                        />
                      </div>
                    </>
                  )}
                />
              </div>
            </div>
            <div className="grid grid-cols-12">
              <div className="col-span-3">
                <div className="text-sm leading-5 font-light font-inter text-gray-300">
                  Send Notifications to
                </div>
                <div className="leading-5 font-light font-inter text-white text-sm mt-2">
                  You will get the notification to your registered email and mobile phone
                </div>
              </div>
              <div className="col-span-3 col-start-5 flex flex-col gap-6">
                <Controller
                  name="notifyEmailOrSms"
                  control={control}
                  defaultValue={state?.notifications?.notificationDestination ?? 'sms'}
                  render={({ field: { onChange, value } }) => (
                    <>
                      <div>
                        <CustomRadio
                          label="Email"
                          id="email"
                          value="email"
                          checked={value === 'email'}
                          onValueChange={(destinationvalue) => onChange(destinationvalue)}
                        />
                      </div>
                      <div>
                        {/* <Radio
                          note="only critical alerts"
                          label="SMS"
                          id="sms"
                          value="sms"
                          checked={value === 'sms'}
                          onValueChange={(destinationvalue) => onChange(destinationvalue)}
                        /> */}
                        <CustomRadio
                          label="SMS"
                          id="sms"
                          value="sms"
                          checked={value === 'sms'}
                          onValueChange={(destinationvalue) => onChange(destinationvalue)}
                        />
                      </div>
                    </>
                  )}
                />
              </div>
            </div>

            {/* Fault Detection & Diagnostics */}
            <div className="grid grid-cols-12">
              <div className="col-span-3">
                <div className="text-sm leading-5 font-light font-inter text-gray-300">
                  Fault Detection & Diagnostics (PRO)
                </div>
                <div className="leading-5 font-light font-inter text-white text-sm mt-2">
                  BETA OPEN Lorem ipsum text explaining the value of this service.
                </div>
              </div>
              <div className="flex items-center h-5 col-span-3 col-start-5">
                <Switch
                  width={36}
                  height={20}
                  onChange={(checked) => setFaultDetection(checked)}
                  checked={faultDetection}
                  uncheckedIcon={false}
                  onColor="#2970FF"
                  checkedIcon={false}
                  handleDiameter={16}
                />
                <span className="text-gray-500 font-medium text-base ml-4">
                  We’ll contact you soon
                </span>
              </div>
            </div>

            {/* Notify when someone resolves a raised issue */}
            <div className="grid grid-cols-12">
              <div className="col-span-3">
                <div className="leading-5 font-light font-inter text-white text-sm">
                  Notify me when someone resolved a raised issue
                </div>
              </div>
              <div className="flex items-center h-5 col-span-3 col-start-5">
                <Switch
                  width={36}
                  height={20}
                  onChange={(checked) => setNotifyResolvedIssue(checked)}
                  checked={notifyResolvedIssue}
                  uncheckedIcon={false}
                  onColor="#2970FF"
                  checkedIcon={false}
                  handleDiameter={16}
                />
              </div>
            </div>

            {/* Notify about activity in raised issue */}
            <div className="grid grid-cols-12">
              <div className="col-span-3">
                <div className="leading-5 font-light font-inter text-white text-sm">
                  Notify about activity in raised issue
                </div>
              </div>
              <div className="flex items-center h-5 col-span-3 col-start-5">
                <Switch
                  width={36}
                  height={20}
                  onChange={(checked) => setNotifyIssue(checked)}
                  checked={notifyIssue}
                  uncheckedIcon={false}
                  onColor="#2970FF"
                  checkedIcon={false}
                  handleDiameter={16}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end">
          <div className="flex items-center gap-5">
            <Button
              size="sm"
              theme="secondary-gray"
              name="Reset to Default"
              loading={loading}
              onClick={() => {
                reset({
                  notifyAllAlerts: 'All Alerts',
                  notifyEmailOrSms: 'email'
                });
                handleOnReset();
              }}
            />
            <Button
              size="sm"
              theme="primary"
              name="Save Changes"
              buttonType="submit"
              loading={loading}
            />
          </div>
        </div>
      </form>
    </div>
  );
}

export default NotificationSettings;
